<!--<c-footer>-->
<div>
  <a href="https://coreui.io/" target="_blank">ManosYa</a>
  <span> &copy; {{ year }}</span>
</div>
<div class="ms-auto">
  Powered by
  <a href="https://coreui.io/angular" target="_blank">
    <span> InnovaX</span>
  </a>
</div>
<!--</c-footer>-->